<template>
  <div class="mm_body">
    <mmheader :mm-site-url="mm_site_url"></mmheader>
    <div style="clear: both;"></div>
    <section class="container" style="padding-top: 72px !important;">
      <div class="text-center text_bebas">
        <div class="mt-5 mb-4 h3 font-weight-bold">Get Started with Mentor Mentee</div>
      </div>

      <div class="row justify-content-center mb-3">
        <div class="col-md-5 col-11">
          <CreateAccountForm></CreateAccountForm>
        </div>        
      </div>

    </section>
    <mmfooter :mm-site-url="mm_site_url"></mmfooter>
  </div>
</template>
<script>
import axios from 'axios';
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import router from '@/router/index.js';
import Multiselect from 'vue-multiselect';
import CreateAccountForm from '@/components/create_account/form.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields' });

import mmheader from '@/components/mm_header';
import mmfooter from '@/components/mm_footer';

export default {
  data() {
    return {
      mm_site_url: process.env.MM_SITE_URL,
      org_name: '',
      org_type: '',
      phone_number: '',
      create_account_errors: false,
      create_account_error_msg: '',
    }
  },
  components: {
    mmheader,
    mmfooter,
    Multiselect,
    CreateAccountForm,
  },
  methods: {
    phoneValid: function (event) {
      var phone = this.phone_number;
      this.phone_number = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    },
    phoneRegex: function () {
      return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    },
    insertAccountUserAction: function () {
      axios('/custom/create-account-insert',
        {
          method: 'POST',
          data: {
            "account": {
              "company_name": this.org_name,
              "master_admin": false,
              "school_flag": 'Company',
              "website": '',
              "phone_no": '',
              "phone_ext": '',
              "fax": '',
              "status": 'Inactive',
              "researcher_notes": '',
              "naics_code": '',
              "naics_id": '',
              "naics_description": '',
              "naics_label": '',
              "location": {
                "address": this.org_address,
                "country_code": this.org_country,
                "state_code": this.org_state,
                "city": this.org_city,
                "zip": this.org_zip,
                "market_area": '',
                "address2": this.mailing_address_2
              },
              "program": 'Mentorship',
              "industry_selected": this.industry_types,
              "is_customer_created_account": 1,
            },
            "userInfo": {
              "uid": 0,
              'admin_fname': this.first_name,
              'admin_lname': this.last_name,
              'admin_email': this.email,
              'password': this.password,
              "phone": this.phone_number,
              "phone_ext": '',
              "mobile": '',
              'id_number': '',
              'admin_title': '',
              'is_enabled': 0,
              'remove_flag': false,
              'last_login': "",
              'no_login': "",
              'is_primaryadmin': 1,
              'is_manager': 1,
              'admin_status': 'Inactive'
            },
          }
        })
        .then(response => {
          this.$router.push({ name: 'mmcreateaccountsuccess' })
        })
        .catch(error => {
          const fieldErrors = [];
          const fieldErrors1 = [];
          var newFieldErr = '';
          var errMsgObj = error.response.data.message;
          Object.keys(errMsgObj).map(key => {
            if (key == 'org name') {
              newFieldErr = "Account name is already exists";
            }
            else {
              newFieldErr = "Email address is already exists";
            }
          });
          this.create_account_error_msg = newFieldErr;
          this.create_account_errors = true;
        });
    },
    getExpiryYears() {
      this.year_options = [
          { value: '', text: 'Year' },
      ];       
      var min = new Date().getFullYear()
      var max = min + 20;
      for (var i = min; i <= max; i++) {
          var yoptions = { value: i, text: i };
          this.year_options.push(yoptions);
      }
    },
  },
  created() {
    this.getExpiryYears();

  },
}
</script>
<style scoped>
@import 'https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@700&display=swap';
.mm_body {
  /* font-size: 20px !important; */
  color: #002F42;
  max-width: 2400px;
  margin: auto;
  font-family: "proxima-nova", Arial, verdana !important;
}

.div-center {
  text-align: center;
}

.heading-1 {
  font-size: 28px;
  padding: 30px 0px 15px 0px;
  font-weight: bold;
}

.heading-2 {
  font-size: 16px;
  padding: 0px 0px 30px 0px;
}

.pad-30 {
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: -20px !important;
  font-size: 1rem;
}

.max-780 {
  max-width: 780px;
  margin: auto;
}

.margin-bottom-30 {
  margin-bottom: 30px;
}

.margin-20 {
  margin: 20px 0px;
}

.margin-bottom-60 {
  margin-bottom: 60px;
}

h3 {
  /* font-family: 'Roboto Condensed', sans-serif; */
  font-weight: bold;
  font-size: 22px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.container {
  /* padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 130px; */
}

.address-search-icon {
  padding-left: 45px;
  background: url('~@/assets/search-icon.png') no-repeat left;
}

.col-md-6 {
  padding-right: 60px;
}

.btn-blue {
  font-size: 18px;
  padding: 2px 30px 2px 30px;
  background-color: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  border-radius: 5px;
}

.button-container {
  margin-top: 20px;
  font-family: 'bebas-neue-pro', sans-serif;
}

::placeholder {
  color: #999;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #999;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #999;
}

/* media query css start */
@media (max-width: 991px) {
  .pad-60 {
    padding: 60px 20px;
  }
}

@media (min-width: 1200px) {
  .container {
    /* width: 850px !important; */
  }
}

@media (min-width:320px) and (max-width: 767px) {
  .container {
    /* width: 100% !important; */
  }
}

/* media query css end */
.custom-radio .custom-control-input~.custom-control-label::before {
  width: 0.9rem;
  height: 0.9rem;
}
</style>
<style>
#industry-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}

#industry-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
  font-family: "proxima-nova", Arial, verdana !important;
}

.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
  font-family: "proxima-nova", Arial, verdana !important;
}

.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}

.multiselect__option {
  font-size: 1rem;
  font-family: "proxima-nova", Arial, verdana !important;
}

.multiselect__option--selected {
  font-size: 1rem;
  font-weight: normal !important;
  font-family: "proxima-nova", Arial, verdana !important;
}

.multiselect,
.multiselect__input,
.multiselect__single {
  font-size: 1rem;
  font-weight: 400;
  color: #707070;
  background-color: inherit !important;
  font-family: "proxima-nova", Arial, verdana !important;
}

.multiselect__placeholder {
  font-size: 16px;
  color: #999;
}
.text_bebas {
    font-family: 'bebas-neue-pro', sans-serif;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/create_account/create.vue